<script setup lang="ts">
interface Stat {
  name: string
  previous_value?: string
  unit?: string
  value: string
}

withDefaults(
  defineProps<{
    color?: string
    stats: Stat[]
  }>(),
  {
    color: 'bg-gray-900',
    stats: null,
  },
)
</script>

<template>
  <div class="rounded-lg" :class="color">
    <div class="mx-auto max-w-7xl">
      <div class="grid grid-cols-1 gap-px bg-white/5 sm:grid-cols-2 lg:grid-cols-4">
        <div v-for="stat in stats" :key="stat.name" class="px-4 py-6 sm:px-6 lg:px-8">
          <p class="mb-2 text-sm font-medium leading-6 text-gray-400">{{ stat.name }}</p>
          <p class="text-lg font-medium leading-6 text-gray-200">
            <del>{{ stat.previous_value }}</del>
          </p>
          <p class="flex items-baseline gap-x-2">
            <span class="value text-3xl font-semibold tracking-tight text-white">{{ stat.value }}</span>
            <span v-if="stat.unit" class="text-sm text-gray-400">{{ stat.unit }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
